const ratingValues = [
  {
    value: '1',
    text: '1'
  },
  {
    value: '2',
    text: '2'
  },
  {
    value: '3',
    text: '3'
  },
  {
    value: '4',
    text: '4'
  },
  {
    value: '5',
    text: '5'
  },
  {
    value: '6',
    text: '6'
  }
];

const questionHeader = {
  type: 'html',
  name: 'HTML_QUESTION_Header',
  html: `
  <div class="">
    <span style="font-size:16px;">
      Por favor indica en qué medida estás de acuerdo o en desacuerdo con las siguientes afirmaciones:
    </span>
    <br />
    <br />
  </div>
  `
};

export const TestIntro = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  // showProgressBar: 'top',
  // progressBarType: 'questions',
  goNextPageAutomatic: false,
  firstPageIsStarted: false,
  showPrevButton: false,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  showQuestionNumbers: 'off',
  requiredText: `*`,
  pages: [
    {
      name: 'EE_PAGE_00_T',
      title: '',
      elements: [
        {
          type: 'html',
          name: 'HTML_DIALOG_01',
          html: `
  <div class="QuestionText BorderColor">
    <span style="font-size:16px;">
      <span style="font-family:arial,helvetica,sans-serif;">
        <h3>Sección 2/5</h3>
      </span>
      <br />
      Las siguientes preguntas son para indagar sobre lo que piensan las personas sobre el desarrollo de habilidades. Algunas personas creen que es fácil cambiar las habilidades, y otras que no.
      <br />
      <br />
      No hay respuestas correctas o incorrectas. Sólo nos interesa conocer tu visión. Por favor, indica en qué medida estás de acuerdo o en desacuerdo con las siguientes afirmaciones utilizando la siguiente escala de 1 a 6 donde 1 es "Totalmente en desacuerdo" 6 es "Totalmente de acuerdo":
      <br />
      <br />
      <div class="qstn-likert-label top">
        <div class="text-center">Totalmente en desacuerdo</div>
      </div>
      <div class="btn-group">
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="1" value="1"><span class="quanta_q_rating_item_text"><span>1</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="2" value="2"><span class="quanta_q_rating_item_text"><span>2</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="3" value="3"><span class="quanta_q_rating_item_text"><span>3</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="4" value="4"><span class="quanta_q_rating_item_text"><span>4</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="5" value="5"><span class="quanta_q_rating_item_text"><span>5</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="5" value="6"><span class="quanta_q_rating_item_text"><span>6</span></span></label>
      </div>
      <div class="qstn-likert-label bottom">
        <div class="text-center">Totalmente de acuerdo</div>
      </div>
    </span>
  </div>
`
        }
      ]
    }
  ]
};

const ITEMS = [
  {
    code: 'ABIL_01',
    statement:
      '1.- Las personas tienen ciertas habilidades y no hay mucho que hacer para mejorarlas'
  },
  {
    code: 'ABIL_02',
    statement:
      '2.- Las habilidades son características de nacimiento que no se pueden mejorar mucho'
  },
  {
    code: 'ABIL_03',
    statement:
      '3.- No importa quién seas, todos pueden aumentar significativamente sus habilidades'
  },
  {
    code: 'ABIL_04',
    statement: '4.- Siempre se puede hacer algo para mejorar tus habilidades'
  },
  {
    code: 'ABIL_05',
    statement:
      '5.- Uno puede aprender nuevas cosas pero en realidad no puede cambiar sus habilidades de base'
  },
  {
    code: 'ABIL_06',
    statement:
      '6.- Cuando alguien tiene un nivel muy alto de habilidades, es difícil que pueda mejorarlas'
  }
];

const itemPages = ITEMS.map(item => {
  const { code, statement } = item;
  return {
    name: code,
    title: '',
    elements: [
      questionHeader,
      {
        type: 'rating',
        name: code,
        title: statement,
        isRequired: true,
        minRateDescription: 'Totalmente en desacuerdo',
        maxRateDescription: 'Totalmente de acuerdo',
        rateValues: ratingValues
      }
    ]
  };
});

const ITEMS_2 = [
  {
    code: 'ABIND_01',
    statement:
      '1.- **Habilidad numérica** — como la capacidad general para entender conceptos matemáticos, resolver problemas numéricos y hacer cálculos mentales'
  },
  {
    code: 'ABIND_02',
    statement:
      '2.- **Habilidad verbal** — como la comprensión de lectura, la capacidad para expresar ideas o analizar un problema de forma escrita y la amplitud de vocabulario.'
  },
  {
    code: 'ABIND_03',
    statement:
      '3.- **Memoria** — incluyendo la capacidad para retener información en el corto plazo (como una lista de compras o un número de teléfono) y en el largo plazo (como nombres de personas y lugares, recordar eventos pasados en detalle) '
  },
  {
    code: 'ABIND_04',
    statement:
      '4.- **Habilidades artísticas** — incluyendo la capacidad para realizar actividades creativas como dibujar o pintar, componer una canción o cantar.'
  },
  {
    code: 'ABIND_05',
    statement:
      '5.- **Habilidades deportivas** — como la capacidad aeróbica, la fuerza física y la coordinación motora.'
  },
  {
    code: 'ABIND_06',
    statement:
      '6.- **Habilidad de aprendizaje** — incluyendo la capacidad para usar nuevas estrategias de estudio y para mantener la atención, el esfuerzo y la motivación frente a los desafíos del estudio'
  }
];

const itemIndPages = ITEMS_2.map(item => {
  const { code, statement } = item;
  return {
    name: code,
    title: '',
    elements: [
      {
        type: 'html',
        name: 'HTML_QUESTION_Header',
        html: `
        <div class="">
          <span style="font-size:16px;">
          Indica qué tan posible crees que es mejorar tu nivel actual de la siguiente habilidad:
          </span>
          <br />
          <br />
        </div>
        `
      },
      {
        type: 'rating',
        name: code,
        title: statement,
        isRequired: true,
        minRateDescription:
          'Es imposible que mejore, no importa cuánto me esfuerce',
        maxRateDescription:
          'Definitivamente puedo mejorar si me esfuerzo lo suficiente',
        rateValues: [
          {
            value: '1',
            text: '1'
          },
          {
            value: '2',
            text: '2'
          },
          {
            value: '3',
            text: '3'
          },
          {
            value: '4',
            text: '4'
          },
          {
            value: '5',
            text: '5'
          }
        ]
      }
    ]
  };
});

const baseInfo = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  showProgressBar: 'top',
  progressBarType: 'pages',
  goNextPageAutomatic: true,
  firstPageIsStarted: false,
  showPrevButton: true,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  showQuestionNumbers: 'off',
  requiredText: ``,
  pages: [
    ...itemPages,
    {
      name: 'EE_PAGE_01_M',
      title: '',
      elements: [
        {
          type: 'html',
          name: 'HTML_DIALOG_01_DIM',
          html: `
<div class="QuestionText BorderColor">
  <span style="font-size:16px;">
    <span style="font-family:arial,helvetica,sans-serif;">
      <h3>Sección 3/5</h3>
    </span>
    <br />
    Ahora, debes indicar qué tan posible crees que es para ti el poder mejorar tu nivel actual en las las habilidades específicas que aparecerán a continuación. Para esto, utilizaremos la siguiente escala:
    <br />
    <br />
    <div class="qstn-likert-label top">
      <div class="text-center">Es imposible que mejore, no importa cuánto me esfuerce</div>
    </div>
    <div class="btn-group">
      <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="1" value="1"><span class="quanta_q_rating_item_text"><span>1</span></span></label>
      <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="2" value="2"><span class="quanta_q_rating_item_text"><span>2</span></span></label>
      <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="3" value="3"><span class="quanta_q_rating_item_text"><span>3</span></span></label>
      <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="4" value="4"><span class="quanta_q_rating_item_text"><span>4</span></span></label>
      <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="5" value="5"><span class="quanta_q_rating_item_text"><span>5</span></span></label>
    </div>
    <div class="qstn-likert-label bottom">
      <div class="text-center">Definitivamente puedo mejorar si me esfuerzo lo suficiente</div>
    </div>
  </span>
</div>
`
        }
      ]
    },
    ...itemIndPages
  ]
};

export default baseInfo;
